import request from '@/utils/request'

// 内容审核列表（默认只返回待人工复核的动态）
export function getContentAuditList(params) {
  return request({
    url: '/admin/content-audit/list',
    method: 'get',
    params
  })
}

// 人工通过：动态进入公共列表，涉及的图片一并放行
export function approveContentAudit(id, data) {
  return request({
    url: `/admin/content-audit/${id}/approve`,
    method: 'post',
    data
  })
}

// 人工驳回：动态不再对外可见，必须填写原因
export function rejectContentAudit(id, data) {
  return request({
    url: `/admin/content-audit/${id}/reject`,
    method: 'post',
    data
  })
}

// ── 评论 / 回复审核 ─────────────────────────────────────────────
// targetType: 'COMMENT'（一级评论）| 'REPLY'（楼中楼回复）
// 权限沿用 /audit/moment 菜单 —— 评论审核与动态审核是同一页面的两个 tab，
// 刻意不新增菜单（新增要改 MenuConstant 静态块，必须重启后端才生效）。
export function getCommentAuditList(params) {
  return request({
    url: '/admin/comment-audit/list',
    method: 'get',
    params
  })
}

// 通过：评论 / 回复对外展示（回复会补一次 reply_count +1）
export function approveCommentAudit(targetType, id, data) {
  return request({
    url: `/admin/comment-audit/${targetType}/${id}/approve`,
    method: 'post',
    data
  })
}

// 驳回：正文换成「此内容已违规」占位、楼层保留（与举报成立的展示一致）
export function rejectCommentAudit(targetType, id, data) {
  return request({
    url: `/admin/comment-audit/${targetType}/${id}/reject`,
    method: 'post',
    data
  })
}
